<template>
  <div>
    <label
      v-if="!hideLabels"
      class="replacement-label"
    >{{ label }}</label>
    <div
      class="form-row hide-label"
      :class="{'form-wrapper__error': hasError }"
    >
      <div
        v-for="option in options"
        :key="option.id"
        :class="inputsWrappingClass"
      >
        <div class="check-btn">
          <button
            :id="uniqueId(option)"
            type="button"
            :value="option.id"
            :required="required"
            :class="buttonClasses(option)"
            :name="name"
            @click="selectOption(option)"
          >
            {{ option.display_label }}
          </button>
        </div>
      </div>

      <div class="col-12">
        <p
          v-show="hasError"
          class="form__error"
        >
          {{ error }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// todo: this could probably just replace input radio component b/c its more flexible and doesn't reply on the checked attr
export default {
  $_veeValidate: {
    name() {
      return this.name;
    },
    value() {
      return this.value;
    },
  },
  props: {

    // for survey
    hideLabels: {
      type: Boolean,
      default: false,
    },
    allowTwoStack: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    forceFullWidthInputs: {
      type: Boolean,
      default: false,
    },

    value: {
      type: Array,
      default: null,
    },
    label: {
      type: String,
      default: 'Form Label',
    },
    name: {
      type: String,
      default: 'form-name',
    },
    id: {
      type: String,
      default: 'form-id',
    },
    // disabled: {
    //   type: Boolean,
    //   default: false,
    // },
    required: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
      required: false,
    },

    options: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      selectedOptions: this.value,
    };
  },
  watch: {
    value() {
      this.selectedOptions = this.value
    }
  },
  computed: {
    inputsWrappingClass() {
      if (this.allowTwoStack && this.options.length > 5) {
        return 'col-12 col-sm-6';
      }

      if (!this.forceFullWidthInputs) {
        if (this.options.length === 5 || this.options.length === 6) {
          return 'col-12 col-md-2';
        }

        if (this.options.length === 4) {
          return 'col-12 col-md-3';
        }

        if (this.options.length === 3) {
          return 'col-12 col-md-4';
        }

        if (this.options.length === 2) {
          return 'col-12 col-md-6';
        }
      }

      return 'col-12';
    },
  },
  methods: {
    selectOption(option) {
      if (this.multiple) {
        const index = this.selectedOptions.indexOf(option.id)
        if (index === -1) {
          this.selectedOptions.push(option.id)
        } else {
          this.selectedOptions.splice(index, 1)
        }
      } else {
        this.selectedOptions = [option.id]
      }

      this.$forceUpdate();
      
      this.$emit('input', this.selectedOptions);
    },
    buttonClasses(option) {
      if (this.selectedOptions.indexOf(option.id) > -1) {
        return 'input selected';
      }
      return 'input';
    },
    uniqueId(option) {
      return `chk_${this.name}_${option.id}`;
    },
  },
};
// todo: style buttons below
</script>

<style lang="scss" scoped>
  button {
    @include border-radius($border-radius);

    position: relative;
    display: inline-block !important;
    width: 100%;
    max-width: 100%;
    height: 45px;
    margin-bottom: 15px;
    padding: 0;
    border: $default-border;
    cursor: text;
    background: rgba(33, 54, 75, 1);
    color: white;
    text-align: center;
    line-height: 43px;

    &:hover {
      cursor: pointer;
      background: rgba(white, 0.2);
    }

    &.selected {
      background: $green;
      border: solid 1px $green;
      color: $btn-color;
    }
  }

  .hide-label {
    ::v-deep label {
      display: none;
    }
  }

  .form-wrapper__error {
    input,
    label {
      border: solid 1px $red !important;
      outline: 0 !important;
      box-shadow: none !important;
    }

    .form__error {
      max-height: 200px;
      padding-bottom: 1rem;
      color: $red;
      transition: max-height 0.3s ease-out;
      position: relative;
      margin-top: -10px;
    }
  }
</style>
